export const configConstants = {
  SOUNDS_ENABLED: "SOUNDS_CONFIG_SOUNDS_ENABLED",
  SOUNDS_DISABLED: "SOUNDS_CONFIG_SOUNDS_DISABLED",
  SOUNDS_TOGGLE_STATE: "SOUNDS_CONFIG_SOUNDS_TOGGLE_STATE",
};
